import './App.css';
import {Main} from './components/Main'
import {PosSoftware} from './components/PosSoftware'
import {OnlineStore} from './components/OnlineStore'
import {Security} from './components/Security'
import {Reports} from './components/Reports'
import {Crm} from './components/Crm'
import {Vendors} from './components/Vendors'
import {Inventory} from './components/Inventory'
import {Multicat} from './components/Multicat'
import AccountRegistration from './components/AccountRegistration';
import React from 'react'
import {
  Routes,
  Route,
  Outlet,
  Link,
  useMatch,
  useResolvedPath,
} from "react-router-dom";
import Layout from './Layout';
import { Downloads } from './components/Downloads';


function App() {
  // const router = createBrowserRouter([
  //   {
  //     path: "/",
  //     element: <Main/>,
  //   },
  //   {
  //     path: "pos",
  //     element: <PosSoftware/>,
  //   },
  //   {
  //     path: "multicat",
  //     element: <Multicat/>,
  //   },
  //   {
  //     path: "online",
  //     element: <OnlineStore/>,
  //   },
  //   {
  //     path: "registeraccount",
  //     element: <AccountRegistration/>,
  //   },
  // ]);

  return (
    <div className="App">
      {/* <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container">
          <img src="/images/BronzeColorTag.png" style={{width: 40, height: 40}}/>
          <a style={{marginLeft: 8}} className="navbar-brand" href="index.html">BronzeTag</a>
          <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link" href="accountregistration">Register</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <RouterProvider router={router} />
      
      
  
      <footer className="py-5 bg-dark">
        <div className="container">
          <p className="m-0 text-center text-white">Copyright &copy; BronzeTag.com 2022</p>
        </div>
        
      </footer> */}

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Main />} />
          <Route path="pos" element={<PosSoftware />} />
          <Route path="security" element={<Security />} />
          <Route path="reports" element={<Reports />} />
          <Route path="crm" element={<Crm />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="pos/download" element={<Downloads />} />
          <Route path="online" element={<OnlineStore />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="multicat" element={<Multicat />} />
          <Route path="registeraccount" element={<AccountRegistration />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;

function NoMatch() {
  return (
    <div>
      <h1>Nothing to see here!</h1>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}
